import { Component } from 'react';

export class ErrorStatusSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid={this.props['data-testid']}
                fill="none"
                width="20px"
                height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
            >
                <g clipPath="url(#clip0)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 20l3.2-3.2a.7.7 0 01-.2-.5V16h-.3a.7.7 0 01-.7-.7V4.7c0-.4.3-.7.7-.7H3v-.3c0-.2 0-.4.2-.5L0 0l3.2 3.2.5-.2H4v-.3c0-.4.3-.7.7-.7h10.6c.4 0 .7.3.7.7V3h.3c.2 0 .4 0 .5.2L20 0l-3.2 3.2.2.5V4h.3c.4 0 .7.3.7.7v10.6c0 .4-.3.7-.7.7H17v.3c0 .2 0 .4-.2.5L20 20l-3.2-3.2-.5.2H16v.3c0 .4-.3.7-.7.7H4.7a.7.7 0 01-.7-.7V17h-.3c-.2 0-.4 0-.5-.2L0 20zm16.8-3.2l.2-.5V16h-1l.8.8zM16 16l.8.8-.5.2H16v-1zm0 0v-.7a8 8 0 01-.3.4l.3.3zm-.3-.3l.3.3h-.7l.4-.3zm0 0c0-.2.2-.3.3-.4v-4.7a6 6 0 01-1.7 3.6l1.4 1.4zm-1.5-1.4l1.4 1.4a8 8 0 01-.3.3h-4.7a6 6 0 003.6-1.7zm0 0a6 6 0 000-8.4L13 7a4 4 0 010 5.6l1.3 1.4zm-1.4-1.4l1.4 1.3a6 6 0 01-8.4 0L7.2 13a4 4 0 005.6 0zm0-.1a4 4 0 000-5.6L10 10l2.8 2.8zM10 10l2.8 2.8a4 4 0 01-5.6 0L10 10zm0 0l2.8-2.8a4 4 0 00-5.6 0L10 10zM7.2 7.2L10 10l-2.8 2.8a4 4 0 010-5.6zm0 0a4 4 0 015.6 0l1.4-1.4a6 6 0 00-8.4 0L7.2 7zM5.8 5.7L7 7.2a4 4 0 000 5.6l-1.3 1.4a6 6 0 010-8.4zm0 0A6 6 0 019.4 4H4.7a8 8 0 00-.3.3l1.4 1.4zM4.3 4.3l1.4 1.4A6 6 0 004 9.4V4.7l.3-.3zm0 0l.4-.4H4l.3.3zM4 4l.3.3a8 8 0 00-.3.4V4zm0 0V3h-.3c-.2 0-.4 0-.5.2L4 4zm-.8-.8L4 4H3v-.3c0-.2 0-.4.2-.5zM3.7 17c-.2 0-.4 0-.5-.2L4 16v1h-.3zm-.5-.2L4 16H3v.3c0 .2 0 .4.2.5zm1.5-.8H4l.3-.3.4.3zM4 16l.3-.3a8 8 0 01-.3-.4v.7zm.7 0a8 8 0 01-.3-.3l1.4-1.4A6 6 0 009.4 16H4.7zm-.4-.4l1.4-1.4A6 6 0 014 10.6v4.7l.3.3zM16 9.4a6 6 0 00-1.7-3.6l1.4-1.4.3.3v4.7zm-1.8-3.7l1.4-1.4a8 8 0 00-.3-.3h-4.7a6 6 0 013.6 1.7zm1.8-1a8 8 0 00-.3-.4L16 4v.7zm-.3-.4L16 4h-.7l.4.3zM17 4h-1l.8-.8.2.5V4zm-1 0l.8-.8a.7.7 0 00-.5-.2H16v1zm0-1v-.3c0-.4-.3-.7-.7-.7h-4.6A8 8 0 0114 3h2zm-2 0h2v1h-.7a8 8 0 00-1.4-1zm-.2 0a8 8 0 00-7.6 0h7.6zm0 0c.6.3 1 .6 1.4 1H4.8A8 8 0 016 3H14zM6.2 3c1-.5 2-.9 3.2-1H4.7c-.4 0-.7.3-.7.7V3h2.1zm-2 0h2a8 8 0 00-1.4 1H4V3zM3 4h-.3c-.4 0-.7.3-.7.7v4.6A8 8 0 013 6v-2zm0 2V4h1v.7a8 8 0 00-1 1.4zm0 .2a8 8 0 000 7.6V6.2zm0 0c.3-.6.6-1 1-1.4v10.4A8 8 0 013 14V6zm0 7.7a8 8 0 01-1-3.2v4.6c0 .4.3.7.7.7H3v-2.1zm0 2v-2l1 1.4v.7H3zM4 17v.3c0 .4.3.7.7.7h4.6A8 8 0 016 17h-2zm2 0H4v-1h.7l1.4 1zm.2 0a8 8 0 007.6 0H6.2zm7.7 0H6a8 8 0 01-1.3-1h10.4a8 8 0 01-1.3 1zm0 0a8 8 0 01-3.2 1h4.6c.4 0 .7-.3.7-.7V17h-2.1zm2 0h-2a8 8 0 001.4-1h.7v1zm1.1-1h.3c.4 0 .7-.3.7-.7v-4.6a8 8 0 01-1 3.2v2zm0-2v2h-1v-.7a8 8 0 001-1.4zm0-.2a8 8 0 000-7.6v7.6zm0-7.7V14a8 8 0 01-1 1.3V4.8L17 6zm0 0c.5 1 .9 2 1 3.2V4.7c0-.4-.3-.7-.7-.7H17v2.1zm0-2v2a8 8 0 00-1-1.4V4h1z"
                        fill="#fff"
                    />
                    <circle
                        cx="10"
                        cy="10"
                        r="7.5"
                        fill="#FB534A"
                        stroke="#FB534A"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 5c.6 0 1 .4 1 1v6a1 1 0 11-2 0V6c0-.6.4-1 1-1z"
                        fill="#fff"
                    />
                    <circle cx="10" cy="15" r=".5" fill="#fff" stroke="#fff" />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <path d="M0 0h20v20H0V0z" fill="#fff" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
